import { FC } from 'react';
import './ExhibitAboutComponent.scss';
import { EXHIBITION_ABOUT_LABELS } from './model';
import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';

const ExhibitAboutComponent: FC = () => {
	const handleNavigate = (link: string) => {
		window.open(link, '_blank');
	};
	return (
		<div className='exhibit-container'>
			<div className='exhibit-section-container'>
				<h2 className='section-subtitle'>{EXHIBITION_ABOUT_LABELS.section1.title}</h2>
				<p className='exhibit-content'>{EXHIBITION_ABOUT_LABELS.section1.content}</p>
				<ButtonComponent
					text={EXHIBITION_ABOUT_LABELS.section1.buttonText}
					onClick={() => handleNavigate(EXHIBITION_ABOUT_LABELS.section1.buttonLink)}
					style='rounded-button primary'
				/>
			</div>
			<div className='exhibit-section-container'>
				<h2 className='section-subtitle'>{EXHIBITION_ABOUT_LABELS.section2.title}</h2>
				<p className='exhibit-content'>
					{EXHIBITION_ABOUT_LABELS.section2.content}
					<a
						href={EXHIBITION_ABOUT_LABELS.section2.linkContent}
						target='_blank'
						rel='noopener noreferrer'
					>
						{EXHIBITION_ABOUT_LABELS.section2.linkLabel}
					</a>
					.
				</p>
				<ButtonComponent
					text={EXHIBITION_ABOUT_LABELS.section2.buttonText}
					onClick={() => handleNavigate(EXHIBITION_ABOUT_LABELS.section2.buttonLink)}
					style='rounded-button primary'
				/>
			</div>
		</div>
	);
};

export default ExhibitAboutComponent;
